import React from 'react'

const QueenAnnePattern = () => {
  return (
    <div className="absolute top-0 left-0 w-full h-full z-5 bg-white">
      <div className="grid grid-rows-[10%_auto_10%] grid-cols-[10%_auto_10%] w-full h-full gap-1.5">
        <div className="bg-light"></div>
        <div className="bg-light"></div>
        <div className="bg-light"></div>
        <div className="bg-light"></div>
        <div className="bg-light"></div>
        <div className="bg-light"></div>
        <div className="bg-light"></div>
        <div className="bg-light"></div>
        <div className="bg-light"></div>
      </div>
    </div>
  )
}

export default QueenAnnePattern
